<div
    class="sb-grid-wrapper container-xxl py-4 my-5 px-0 px-sm-3 sb-print-layout sb-p-col-landscape-print"
    #insideElement
>
    <div class="justify-content-center dashboard card" *ngIf="grid && grid.panelLayouts">
        <div class="d-flex justify-content-between mt-3 d-print-none">
            <button class="btn link" (click)="cancelPrintPreview()">
                <tabler-icon name="chevron-left" class="me-1"></tabler-icon>
                Exit print preview
            </button>
            <button class="btn link" (click)="btnPrint($event)">
                <tabler-icon name="printer" class="me-1"></tabler-icon>
                Print
            </button>
            <!-- <button mat-button type="button" class="sb-panel-header-button sb-preview-cancel-btn" (click)="cancelPrintPreview()">Cancel</button> -->
        </div>
        <div
            class="sb-print-form sb-print-formVal-selected"
            style="padding: 0 40px"
            [innerHTML]="formattedPrintFormData$ | async"
        ></div>
        <ng-container
            *ngFor="let panelLayout of grid.panelLayouts | portfolioReportFilter"
        >
            <div
                *ngIf="activeMainDiv(panelLayout.panelId)"
                [class]="getLayoutClass(panelLayout)"
                class="main-div"
            >
                <div *ngIf="hasPanelLayouts(panelLayout)">
                    <!-- Insert tab groups if any...  -->
                    <!-- Check if this panel has children who should be in a specific tab group -->
                    <div
                        *ngFor="let pl of panelLayout.panelLayouts; index as i"
                        [ngClass]="getLayoutClass(pl)"
                    >
                        <ng-container *ngIf="hasTabbedPanels(pl)">
                            <mat-tab-group (selectedTabChange)="handleTabChange($event)">
                                <mat-tab
                                    *ngFor="
                                        let pane of pl.tabbedPanels;
                                        let tabIndex = index
                                    "
                                    label="{{ pane.tabHeader }}"
                                >
                                    <app-sb-panel
                                        [panelId]="pane.panelId"
                                        [tabId]="tabIndex"
                                    ></app-sb-panel>
                                </mat-tab>
                            </mat-tab-group>
                        </ng-container>
                        <ng-container *ngIf="hasTabbedPanels(pl) == false">
                            <app-sb-panel [panelId]="pl.panelId"></app-sb-panel>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="hasPanelLayouts(panelLayout)">
                    <!-- Insert tab groups if any...  -->
                    <!-- Check if this panel has children who should be in a specific tab group -->
                    <div
                        *ngFor="let pl of panelLayout.panelLayouts; index as i"
                        [ngClass]="getLayoutClass(pl)"
                    >
                        <ng-container *ngIf="hasTabbedPanels(pl)">
                            <mat-tab-group (selectedTabChange)="handleTabChange($event)">
                                <mat-tab
                                    *ngFor="
                                        let pane of pl.tabbedPanels;
                                        let tabIndex = index
                                    "
                                    label="{{ pane.tabHeader }}"
                                >
                                    <app-sb-panel
                                        [panelId]="pane.panelId"
                                        [tabId]="tabIndex"
                                    ></app-sb-panel>
                                </mat-tab>
                            </mat-tab-group>
                        </ng-container>
                        <ng-container *ngIf="hasTabbedPanels(pl) == false">
                            <app-sb-panel [panelId]="pl.panelId"></app-sb-panel>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="hasPanelLayouts(panelLayout) == false">
                    <ng-container *ngIf="hasTabbedPanels(panelLayout)">
                        <mat-tab-group (selectedTabChange)="handleTabChange($event)">
                            <mat-tab
                                *ngFor="
                                    let pane of panelLayout.tabbedPanels;
                                    let tabIndex = index
                                "
                                label="{{ pane.tabHeader }}"
                            >
                                <app-sb-panel
                                    [panelId]="pane.panelId"
                                    [tabId]="tabIndex"
                                ></app-sb-panel>
                            </mat-tab>
                        </mat-tab-group>
                    </ng-container>
                    <ng-container *ngIf="hasTabbedPanels(panelLayout) == false">
                        <app-sb-panel [panelId]="panelLayout.panelId"></app-sb-panel>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>
